module.exports = __webpack_public_path__ + "static/img/serve3.3692b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IncentiveTravel/serve3.png
// module id = W3qu
// module chunks = 1